module.exports = __webpack_public_path__ + "media/下一个商品.0230bfbe.mp3";